module.exports = __webpack_public_path__ + "img/steering.1a02760f.svg";